import { useState } from "react";
import axiosInstance from "../../redux/helpers/axios";

const ACCENT_FROM = "#E11D74";
const ACCENT_TO = "#EF4444";
const inputClass =
  "mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2";

// campaignSegmentId is passed down from the Categories page's segment selector —
// this form doesn't fetch or choose it itself.
export default function CreateCampaignCategoryForm({
  campaignSegmentId,
  onCreated,
  onCancel,
}) {
  const [name, setName] = useState("");
  const [status, setStatus] = useState({ loading: false, error: null });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedName = name.trim();

    if (!trimmedName) {
      setStatus({ loading: false, error: "Name is required" });
      return;
    }

    if (!campaignSegmentId) {
      setStatus({
        loading: false,
        error: "No segment selected — pick a segment before adding a category",
      });
      return;
    }

    setStatus({ loading: true, error: null });

    try {
      const res = await axiosInstance.post(
        "/admin/campaign/segment/category/create",
        {
          name: trimmedName,
          campaignSegmentId: Number(campaignSegmentId),
        },
      );

      onCreated(res.data.category);
      setName("");
    } catch (err) {
      setStatus({
        loading: false,
        error:
          err?.response?.data?.error ||
          err?.response?.data?.msg ||
          "Failed to create category",
      });
      return;
    }

    setStatus({ loading: false, error: null });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label
          htmlFor="category-name"
          className="block text-sm font-medium text-gray-700"
        >
          Name
        </label>
        <input
          id="category-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Shirts"
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      {status.error && (
        <p className="text-sm text-red-600" role="alert">
          {status.error}
        </p>
      )}

      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 rounded-md border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={status.loading}
          className="flex-1 rounded-md py-2.5 text-sm font-medium text-white transition disabled:opacity-60"
          style={{
            background: `linear-gradient(90deg, ${ACCENT_FROM}, ${ACCENT_TO})`,
          }}
        >
          {status.loading ? "Creating..." : "Create category"}
        </button>
      </div>
    </form>
  );
}
